import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { jwtDecode } from "jwt-decode";

const AuthContext = createContext(null);

const clearStoredSession = () => {
  sessionStorage.removeItem("token");
  sessionStorage.removeItem("user");
  localStorage.removeItem("token");
};

const isExpired = (decoded) => decoded?.exp && decoded.exp * 1000 <= Date.now();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = sessionStorage.getItem("token") || localStorage.getItem("token");
    const savedUser = sessionStorage.getItem("user");

    if (!token) {
      clearStoredSession();
      setLoading(false);
      return;
    }

    try {
      const decoded = jwtDecode(token);
      if (isExpired(decoded)) {
        throw new Error("Session expiree");
      }
      setUser(savedUser ? JSON.parse(savedUser) : decoded);
    } catch (err) {
      clearStoredSession();
    }
    setLoading(false);
  }, []);

  const login = (token, payload) => {
    const decoded = payload || jwtDecode(token);
    sessionStorage.setItem("token", token);
    sessionStorage.setItem("user", JSON.stringify(decoded));
    setUser(decoded);
  };

  const logout = () => {
    clearStoredSession();
    setUser(null);
  };

  const value = useMemo(() => ({ user, loading, login, logout }), [user, loading]);

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
